export enum DocumentStatusOption {
  UPLOADED = '4d207496-be2b-4840-9800-5adacce6119c',
}
